import React, { Component } from 'react';
import '../../App.css';
import {Helmet} from "react-helmet";

import certificate from './img/overview/certificate.jpg';

import office_image1 from './img/overview/abic_office1.jpg';
import office_image2 from './img/overview/abic_office2.jpg';
import office_image3 from './img/overview/abic_office3.jpg';
import office_image4 from './img/overview/abic_office4.jpg';

import office_map from './img/overview/office-map.jpg';

import about_us0 from './img/overview/about_us0.png';
import about_us1 from './img/overview/about_us1.png';
import about_us2 from './img/overview/about_us2.png';

export default class company_info_overview extends Component {
  render() {
      return (
        <>
            <Helmet>
            <meta charSet="utf-8" />
            <title>ABIC エービック カナダ移民＆ビザ【会社概要】</title>
            <meta name="description" content="
            Alexander Business Investment Consultants Inc.(ABIC), エービックカナダ移民＆ビザ事務所, United Kingdom Building Suite 1617, 409 Granville Street Vancouver, BC CANADA V6C 1T2
            " />
          </Helmet>
            <h2>会社概要</h2>
            <p>
                <table>
                    <tr className="colored">
                        <td width={"120px"}>
                            <b>
                                会社名(英語)<br/>
                                会社名(日本語)
                            </b>
                        </td>
                        <td  width="auto">
                            Alexander Business Investment Consultants Inc.(ABIC)<br/>
                            エービックカナダ移民＆ビザ事務所
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b>
                                本社所在地
                            </b>	
                        </td>
                        <td>
                            Suite 1500 -  701 West Georgia Street Vancouver, BC CANADA V7Y 1C6
                        </td>
                    </tr>
                    <tr className="colored">
                        <td>
                            <b>創業</b>
                        </td>
                        <td>
                            2000年11月
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b>代表取締役</b>
                        </td>
                        <td>
                            Terry Jin　（テリー・ジン）
                        </td>
                    </tr>
                    <tr className="colored">
                        <td>
                            <b>業務内容</b>
                        </td>
                        <td>
                            カナダへの移住＆各種移民、ビザ代行のサポート<br/>
                            北米で起業コンサルティング又は投資のサポート<br/>
                            その他ビジネスサポート事業<br/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b>弁護士パートナー</b>
                        </td>
                        <td>
                        下記の分野にて、各弁護士と提携し、リーガルサービスを提供することは可能です。<br/>
                        ・ 移民＆訴訟<br/>
                        ・ 会社法務<br/>
                        ・ ビジネス契約<br/>
                        ・ アメリカ法律事務<br/>
                        ・ ICBC交通事故<br/>

                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b>取引先銀行</b>
                        </td>
                        <td>
                            TD Canada Trust
                        </td>
                    </tr>
                    <tr className="colored">
                        <td>
                            <b>カナダBC州登録<br/>
                                (コンサルタント業)
                            </b>
                        </td>
                        <td>
                            BC0679946
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b>
                                移民協会登録<br/>
                                (カナダ政府承認)
                            </b>
                        </td>
                        <td>
                            MEI YU RCIC#R421895<br/>
                            CICC website www.college-ic.ca/
                        </td>
                    </tr>
                    <tr className="colored">
                        <td>
                            <b>企業理念</b>
                        </td>
                        <td>
                            カナダでより豊かなライフを求め、真剣に就労、移住を考えている人に 対し、移民＆ビザの手続きを含めたトータル的なサポートを行い、クライアントの就職・永住が成功へ導くよう努力する。
                        </td>
                    </tr>

                </table>
            </p>
            <div className="content-bg-blue">
                代理人資格証書
            </div>
            <div className="content">
                カナダ政府公認移民代理の資格を取得(2004年)、カナダ移民協会正規メンバー
            </div>
            <img src={certificate} className="content-pic full-width"/> 
            <div className="about_us_pics">
                <img src={about_us0} className="content-pic"/> 
                <img src={about_us1} className="content-pic"/> 
                <img src={about_us2} className="content-pic"/> 
            </div>
            <div className="content-bg-blue">
                ABIC事務所
            </div>
            <p>
                <div className="overview_pic_container">
                    <div className="main-image">
                        <img src={office_image1} className="content-pic center"/>
                    </div>
                    <div className="side-images">
                        <img src={office_image2} className="content-pic center"/>
                        <img src={office_image3} className="content-pic center"/>
                        <img src={office_image4} className="content-pic center"/>
                    </div>        
                </div>
                <br/>
                <div className="googleMap">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2602.660578606996!2d-123.12078022271893!3d49.282828470742835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54867193480e2d27%3A0x521cb969e4fd941e!2s701%20W%20Georgia%20St%20%231500%2C%20Vancouver%2C%20BC%20V6Z%202P6!5e0!3m2!1sen!2sca!4v1768192412049!5m2!1sen!2sca" width="600" height="450" frameborder="0" style={{border:0}} allowfullscreen="" aria-hidden="false" tabindex="0"></iframe><br/>
                </div>
                <br/>
            </p>
            <div className="content-bg-blue">
                ABICへのご連絡
            </div>
            <p>
                エービックカナダ移民＆ビザ事務所<br/>
                日本語担当：めぐみ、ひさこ、テリー<br/>
                電話：６０４－６８８－１９５６<br/>
                Eメール： <a href="mailto:Japan@ABICanada.com">Japan@ABICanada.com</a><br/>
            </p>
        </>
      );
    }
  }